@use './breadcrumb-vars';
@use './breadcrumb-common';

:host {
  @include breadcrumb-vars.wb-breadcrumb-vars;
  @include breadcrumb-common.wb-breadcrumb;
  @include breadcrumb-common.wb-breadcrumb-end;
}

:host(:last-of-type) {
  @include breadcrumb-common.wb-breadcrumb-last;

  .wb-link {
    @include breadcrumb-common.wb-breadcrumb-last-link;
  }

  .icon {
    @include breadcrumb-common.wb-breadcrumb-last-icon;
  }
}

.icon {
  @include breadcrumb-common.wb-breadcrumb-icon;
}
